import { render } from "./HighlightButtonGroup.vue?vue&type=template&id=7911e2fc"
import script from "./HighlightButtonGroup.vue?vue&type=script&lang=js"
export * from "./HighlightButtonGroup.vue?vue&type=script&lang=js"

import "./HighlightButtonGroup.vue?vue&type=style&index=0&id=7911e2fc&lang=css"
script.render = render

export default script